import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  isLoading: false,
  storeGrievanceTypeData: [],
  storeDepartmentData: [],
  storeStatusData: [],
  storeSeverityData: {},
  storeLOBData: [],
  storeFinalDispositionData: [],
  storeSeasonData: [],
  storeRequesTypeData: [],
  storeComplaintSourceData: [],
  storeComplaintModeData: [],
  storeProductData: [],
  storeGrievanceData: [],
  storeGrievanceDetailsData: [],
  storeUpdateGrievanceDetails: {},
  storeDownloadGrievanceData: [],
  storeGrievanceDocData: [],
  storeGrievanceDocUploadData: [],
  storeCreateGrievanceData: {},
  storeStateMasterData: [],
  storeDistrictMasterData: [],
  storeLocationData: {},
  storeCustomerDetailsSearchData: {},
  storeMemberDetails: [],
  storePolicyDetailsSearchData: {},
  storeGrievanceDescriptionData: {},
  storeSearchData: {},
  storeApplicationSearchData: [],
  selectedApplication: {},
  storeDeleteGreivanceRes: {},
  storeBulkAssignResponse: {},
  storeSelectedBulkAssignData: [],
  storeBulkUploadRes: {},
  storeGrievanceFeedbackInfo: {},
  storeBBFailureTicketsData: {},
  storeBBFlrTcktExcelData: {}
};

export const grievanceSlice = createSlice({
  name: "grievanceType",
  initialState,
  reducers: {
    startLoadingGrievance(state) {
      state.isLoading = true;
    },
    stopLoadingGrievance(state) {
      state.isLoading = false;
    },
    handleGrievanceTypeDataSlice(state, action) {
      state.storeGrievanceTypeData = action.payload;
    },
    handleRequestTypeDataSlice(state, action) {
      state.storeRequesTypeData = action.payload;
    },
    handleLineOfBusinessDataSlice(state, action) {
      state.storeLOBData = action.payload;
    },
    handleDepartmentDataSlice(state, action) {
      state.storeDepartmentData = action.payload;
    },
    handleComplaintSourceDataSlice(state, action) {
      state.storeComplaintSourceData = action.payload;
    },
    handleComplaintModeDataSlice(state, action) {
      state.storeComplaintModeData = action.payload;
    },
    handleFinalDispositionDataSlice(state, action) {
      state.storeFinalDispositionData = action.payload;
    },
    handleSeasonDataSlice(state, action) {
      state.storeSeasonData = action.payload;
    },
    handleProductDataSlice(state, action) {
      state.storeProductData = action.payload;
    },
    handleGrievanceDataSlice(state, action) {
      state.isLoading = false;
      state.storeGrievanceData = action.payload;
    },
    handleGrievanceDetailsDataSlice(state, action) {
      state.isLoading = false;
      state.storeGrievanceDetailsData = action.payload;
    },
    handleUpdateGrievanceDetailsSlice(state, action) {
      state.isLoading = false;
      state.storeUpdateGrievanceDetails = action.payload;
    },
    handleDownloadGrievanceDataSlice(state, action) {
      state.isLoading = false;
      state.storeDownloadGrievanceData = action.payload;
    },
    handleStatusDataSlice(state, action) {
      state.storeStatusData = action.payload;
    },
    handleSeverityDataSlice(state, action) {
      state.storeSeverityData = action.payload;
    },
    handleGrievanceDocSlice(state, action) {
      state.isLoading = false;
      state.storeGrievanceDocData = action.payload;
    },
    handleGrievanceDocUploadSlice(state, action) {
      state.isLoading = false;
      state.storeGrievanceDocUploadData = action.payload;
    },
    handleCreateGrievanceSlice(state, action) {
      state.isLoading = false;
      state.storeCreateGrievanceData = action.payload;
    },
    handleStateMasterSlice(state, action) {
      state.storeStateMasterData = action.payload;
    },
    handleDistrictMasterSlice(state, action) {
      state.isLoading = false;
      state.storeDistrictMasterData = action.payload;
    },
    handleLocationDataSlice(state, action) {
      state.isLoading = false;
      state.storeLocationData = action.payload;
    },
    handleCustomerDetailsSearchDataSlice(state, action) {
      state.isLoading = false;
      state.storeCustomerDetailsSearchData = action.payload;
    },
    handleMemberDetailsSlice(state, action) {
      state.isLoading = false;
      state.storeMemberDetails = action.payload;
    },
    handleApplicationSearchDataSlice(state, action) {
      state.isLoading = false;
      state.storeApplicationSearchData = action.payload;
    },
    handleSelectedApplication(state, action) {
      state.isLoading = false;
      state.selectedApplication = action.payload;
    },
    handlePolicyDetailsSearchDataSlice(state, action) {
      state.isLoading = false;
      state.storePolicyDetailsSearchData = action.payload;
    },
    handleGrievanceDescriptionSearchDataSlice(state, action) {
      state.storeGrievanceDescriptionData = action.payload;
    },
    handleSearchDataSlice(state, action) {
      state.isLoading = false;
      state.storeSearchData = action.payload;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    handleStoreDeleteGrievance(state, action) {
      state.isLoading = false;
      state.storeDeleteGreivanceRes = action.payload;
    },
    handleBulkAssignResponse(state, action) {
      state.isLoading = false;
      state.storeBulkAssignResponse = action.payload;
    },
    handleBulkUploadRes(state, action) {
      state.isLoading = false;
      state.storeBulkUploadRes = action.payload;
    },
    addSelectedBulkAssignData: (state, action) => {
      const newItem = action.payload;
      if (!state.storeSelectedBulkAssignData.some((item: any) => item.grievanceId === newItem.grievanceId)) {
        state.storeSelectedBulkAssignData.push(newItem);
      }
    },
    removeSelectedBulkAssignData: (state, action) => {
      const grievanceId = action.payload;
      state.storeSelectedBulkAssignData = state.storeSelectedBulkAssignData.filter(
        (item: any) => item.grievanceId !== grievanceId
      );
    },
    clearSelectedBulkAssignData: (state) => {
      state.storeSelectedBulkAssignData = [];
    },
    setBulkAssignData: (state, action) => {
      state.storeSelectedBulkAssignData = action.payload;
    },
    handleStoreGrievanceFeedbackInfo(state, action) {
      state.isLoading = false;
      state.storeGrievanceFeedbackInfo = action.payload;
    },
    handleSetBBFailureTickets: (state, action) => {
      state.storeBBFailureTicketsData = action.payload;
    },
    handleSetBBFlrTcktExcel: (state, action) => {
      state.storeBBFlrTcktExcelData = action.payload;
    }
  },
});

export const {
  handleGrievanceTypeDataSlice,
  handleDepartmentDataSlice,
  handleComplaintSourceDataSlice,
  handleComplaintModeDataSlice,
  handleLineOfBusinessDataSlice,
  handleRequestTypeDataSlice,
  handleProductDataSlice,
  handleGrievanceDataSlice,
  handleGrievanceDetailsDataSlice,
  handleUpdateGrievanceDetailsSlice,
  handleDownloadGrievanceDataSlice,
  handleStatusDataSlice,
  handleGrievanceDocSlice,
  handleGrievanceDocUploadSlice,
  handleCreateGrievanceSlice,
  handleStateMasterSlice,
  handleDistrictMasterSlice,
  handleLocationDataSlice,
  handleCustomerDetailsSearchDataSlice,
  handleMemberDetailsSlice,
  handlePolicyDetailsSearchDataSlice,
  handleGrievanceDescriptionSearchDataSlice,
  handleSearchDataSlice,
  startLoadingGrievance,
  stopLoadingGrievance,
  hasError,
  handleApplicationSearchDataSlice,
  handleSelectedApplication,
  handleStoreDeleteGrievance,
  handleFinalDispositionDataSlice,
  handleSeasonDataSlice,
  handleBulkAssignResponse,
  handleBulkUploadRes,
  clearSelectedBulkAssignData,
  removeSelectedBulkAssignData,
  addSelectedBulkAssignData,
  setBulkAssignData,
  handleStoreGrievanceFeedbackInfo,
  handleSeverityDataSlice,
  handleSetBBFailureTickets,
  handleSetBBFlrTcktExcel
} = grievanceSlice.actions;
export default grievanceSlice.reducer;
